export const formatCurrency = (amount: number, currency: string): string => {
    return new Intl.NumberFormat(undefined, {
        // undefined = user's locale
        style: 'currency',
        currency: currency,
    }).format(amount);
};
